import { c as _c } from "react/compiler-runtime";
import { addHours, startOfHour, sub, subDays } from 'date-fns';
import { Form, Formik } from 'formik';
import { useContext } from 'react';
import { APISource } from '../../../../../../../../typings/Source.interface';
import field_formats from '../../../../../utils/field-formatters';
import formatMetricsQuery from '../../../../../utils/formatMetricsQuery';
import Button from '../../../../common/base/Button';
import { StyledCardSection } from '../../../../common/base/Card';
import Icon, { IconName } from '../../../../common/base/Icon';
import Text from '../../../../common/base/Text';
import Tooltip from '../../../../common/base/Tooltip';
import CopyableField from '../../../../common/CopyableField';
import DropdownMenu, { DropdownMenuOption } from '../../../../common/DropdownMenu';
import { StyledField } from '../../../../common/Form/Fields/SelectInput';
import TextAreaInput from '../../../../common/Form/Fields/TextAreaInput';
import { Div } from '../../../../common/helpers/StyledUtils';
import PreviewHistogram from '../../../../common/Histogram/PreviewHistogram';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import useMetricsQuery from '../../../../hooks/useMetricsQuery';
import { DashboardContext } from '../../DashboardContext';
import resource_details_form_props from '../Forms/resource_details';
import { ResourcesContext } from '../ResourcesContext';
import useOnDelete from './hooks/useOnDeleteToggle';
import useOnDisableToggle from './hooks/useOnDisableToggle';
import { StatusBadge, tooltip_status } from './StatusBadge';
import { PreviewTypeContainer } from './PreviewTypeContainer';
type SourcePreviewField = 'name' | 'type' | 'url' | 'status' | 'requests' | 'open' | 'disable' | 'delete';
interface Props {
  source: APISource;
  fields?: SourcePreviewField[];
  mutate?: () => any;
}
const now = addHours(startOfHour(new Date()), 1);
const SourcePreview = t0 => {
  const $ = _c(75);
  const {
    source,
    fields,
    mutate
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    source_types
  } = useContext(DashboardContext);
  const {
    mutateResourceType
  } = useContext(ResourcesContext);
  const {
    addToast
  } = useToasts();
  const onDisable = useOnDisableToggle("sources", mutate);
  const onDelete = useOnDelete("sources");
  let t1;
  if ($[0] !== fields) {
    t1 = fields ? fields.includes("status") : true;
    $[0] = fields;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const show_status = t1;
  let t2;
  if ($[2] !== fields) {
    t2 = fields ? fields.includes("type") : true;
    $[2] = fields;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const show_type = t2;
  let t3;
  if ($[4] !== fields) {
    t3 = fields ? fields.includes("name") : true;
    $[4] = fields;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const show_name = t3;
  let t4;
  if ($[6] !== fields) {
    t4 = fields ? fields.includes("url") : true;
    $[6] = fields;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const show_url = t4;
  let t5;
  if ($[8] !== fields) {
    t5 = fields ? fields.includes("requests") : true;
    $[8] = fields;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const show_requests = t5;
  let t6;
  if ($[10] !== fields) {
    t6 = fields ? fields.includes("open") : true;
    $[10] = fields;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const show_open = t6;
  let t7;
  if ($[12] !== fields) {
    t7 = fields ? fields.includes("disable") : true;
    $[12] = fields;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const show_disable = t7;
  let t8;
  if ($[14] !== fields) {
    t8 = fields ? fields.includes("delete") : true;
    $[14] = fields;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const show_delete = t8;
  const source_type = source_types?.[source.type];
  let t9;
  if ($[16] !== source.id) {
    const query_params = {
      filters: {
        date: {
          min: subDays(now, 1).toISOString(),
          max: now.toISOString()
        },
        source_id: [source.id]
      },
      granularity: "hour" as const,
      dimensions: ["status"]
    };
    t9 = formatMetricsQuery("Requests", query_params);
    $[16] = source.id;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const metrics_query = t9;
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      resetResultSetOnChange: false
    };
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const {
    raw_data
  } = useMetricsQuery(metrics_query, t10);
  let t11;
  if ($[19] !== raw_data) {
    const data = [...(raw_data ? raw_data.map(_temp) : [])];
    t11 = Array.from(Array(12).keys()).reduce((arr, i) => {
      const step_start = sub(now, {
        hours: i * 2
      });
      const step_end = sub(step_start, {
        hours: 2
      });
      const entries = data.filter(entry_0 => step_end.getTime() < new Date(entry_0.created_at).getTime() && step_start.getTime() >= new Date(entry_0.created_at).getTime());
      const entry_1 = entries.reduce(_temp2, {
        values: {}
      });
      arr.push([[step_start, step_end], entry_1.values]);
      return arr;
    }, []).reverse();
    $[19] = raw_data;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const timeseries_data = t11;
  let dropdown_options;
  if ($[21] !== onDelete || $[22] !== onDisable || $[23] !== show_delete || $[24] !== show_disable || $[25] !== source) {
    dropdown_options = [] as DropdownMenuOption[];
    if (show_disable) {
      let t12;
      if ($[27] !== onDisable || $[28] !== source) {
        t12 = source.disabled_at ? {
          label: "Enable source",
          icon: "enable",
          onClick: () => onDisable(source, false)
        } : {
          label: "Disable source",
          icon: "disable",
          onClick: () => onDisable(source, true)
        };
        $[27] = onDisable;
        $[28] = source;
        $[29] = t12;
      } else {
        t12 = $[29];
      }
      dropdown_options.push(t12);
    }
    if (show_delete) {
      let t12;
      if ($[30] !== onDelete || $[31] !== source) {
        t12 = {
          label: "Delete source",
          icon: "delete",
          danger: true,
          onClick: () => onDelete(source)
        };
        $[30] = onDelete;
        $[31] = source;
        $[32] = t12;
      } else {
        t12 = $[32];
      }
      dropdown_options.push(t12);
    }
    $[21] = onDelete;
    $[22] = onDisable;
    $[23] = show_delete;
    $[24] = show_disable;
    $[25] = source;
    $[26] = dropdown_options;
  } else {
    dropdown_options = $[26];
  }
  let t12;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      t: 4
    };
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== show_status || $[35] !== source) {
    t13 = show_status && <Div p={{
      x: 4,
      b: 4
    }} flex={{
      gap: 2,
      align: "center"
    }}><StatusBadge resource={source} /><Tooltip tooltip={tooltip_status("source", source)} side="bottom"><Icon muted={true} icon="info" /></Tooltip></Div>;
    $[34] = show_status;
    $[35] = source;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  const t14 = `${source_type?.label}-${source.id}`;
  let t15;
  if ($[37] !== HookdeckAPI.sources || $[38] !== addToast || $[39] !== mutate || $[40] !== mutateResourceType || $[41] !== source.id || $[42] !== source_type?.label) {
    t15 = (values, t16) => {
      const {
        resetForm
      } = t16;
      HookdeckAPI.sources.update(source.id, {
        name: values.name
      }).then(updated_source => {
        mutateResourceType?.("sources", updated_source);
        resetForm({
          values: {
            name: updated_source.name,
            type: source_type?.label
          },
          touched: {}
        });
        mutate?.();
        addToast("success", "Source updated");
      });
    };
    $[37] = HookdeckAPI.sources;
    $[38] = addToast;
    $[39] = mutate;
    $[40] = mutateResourceType;
    $[41] = source.id;
    $[42] = source_type?.label;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== HookdeckAPI.sources.nameIsUsed) {
    t16 = values_0 => resource_details_form_props.validate(values_0, HookdeckAPI.sources.nameIsUsed);
    $[44] = HookdeckAPI.sources.nameIsUsed;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  const t17 = source_type?.label;
  let t18;
  if ($[46] !== source.name || $[47] !== t17) {
    t18 = {
      name: source.name,
      type: t17
    };
    $[46] = source.name;
    $[47] = t17;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== dropdown_options || $[50] !== show_delete || $[51] !== show_disable || $[52] !== show_name || $[53] !== show_open || $[54] !== show_requests || $[55] !== show_type || $[56] !== show_url || $[57] !== source.authenticated || $[58] !== source.id || $[59] !== source.type || $[60] !== source.url || $[61] !== source_type?.icon || $[62] !== source_type?.label || $[63] !== source_types || $[64] !== timeseries_data) {
    t19 = t20 => {
      const {
        dirty,
        resetForm: resetForm_0,
        isSubmitting,
        isValid
      } = t20;
      return <Form><StyledCardSection p={{
          x: 4,
          b: 4
        }}>{show_type && <Div m={{
            bottom: 4
          }}><StyledField block={true}><Text muted={true} semi={true} size="xs" m={{
                b: 1
              }}>Source type</Text><PreviewTypeContainer icon={source_type?.icon as IconName} label={source_type?.label ?? ""} authenticated={source.authenticated} /></StyledField></Div>}{show_name && <TextAreaInput mono={true} name="name" label="Source Name" required={true} auto_resize={true} format={field_formats.slugify} m={{
            b: !show_url || !show_requests ? 0 : 4
          }} maxlength={155} />}{show_url && (source_types?.[source.type]?.features?.PUBLISH_API ? <><Text muted={true} semi={true} size="xs" m={{
              b: 1,
              t: 4
            }}>Source ID</Text><CopyableField mono={true} value={source.id} /></> : <><Text muted={true} semi={true} size="xs" m={{
              b: 1,
              t: 4
            }}>Source URL</Text><CopyableField mono={true} value={source.url} /></>)}{show_requests && <><Div flex={true} m={{
              t: 4,
              b: 2
            }}><Text semi={true} size="xs">Requests</Text><Text muted={true} semi={true} size="xs" m={{
                x: 1
              }}>{" \xB7 "}</Text><Text muted={true} semi={true} size="xs">Last 24h</Text></Div><PreviewHistogram values={timeseries_data} resolution="hour" dimensions_config={{
              accepted: {
                label: "Accepted",
                color: "green_histogram"
              },
              rejected: {
                label: "Rejected",
                color: "red_histogram"
              }
            }} show_tooltip={true} size="medium" /></>}</StyledCardSection><StyledCardSection p={{
          x: 4,
          y: 3
        }} flex={{
          justify: "flex-end",
          gap: 3
        }}>{dirty || !show_open && !show_disable && !show_delete ? <>{dirty && <Button onClick={() => resetForm_0()} outline={true}>Cancel</Button>}<Button submit={true} primary={true} icon="save" disabled={isSubmitting || !isValid || !dirty}>{isSubmitting ? <Icon icon="loading" /> : "Save"}</Button></> : <>{show_open && <Button to={`/sources/${source.id}`} outline={true} icon="open">Open</Button>}{show_disable || show_delete && <DropdownMenu.Permission outline={true} portal={true} icon="horizontal_more" placement="bottom-end" options={dropdown_options} />}</>}</StyledCardSection></Form>;
    };
    $[49] = dropdown_options;
    $[50] = show_delete;
    $[51] = show_disable;
    $[52] = show_name;
    $[53] = show_open;
    $[54] = show_requests;
    $[55] = show_type;
    $[56] = show_url;
    $[57] = source.authenticated;
    $[58] = source.id;
    $[59] = source.type;
    $[60] = source.url;
    $[61] = source_type?.icon;
    $[62] = source_type?.label;
    $[63] = source_types;
    $[64] = timeseries_data;
    $[65] = t19;
  } else {
    t19 = $[65];
  }
  let t20;
  if ($[66] !== t14 || $[67] !== t15 || $[68] !== t16 || $[69] !== t18 || $[70] !== t19) {
    t20 = <Formik key={t14} onSubmit={t15} validate={t16} initialValues={t18}>{t19}</Formik>;
    $[66] = t14;
    $[67] = t15;
    $[68] = t16;
    $[69] = t18;
    $[70] = t19;
    $[71] = t20;
  } else {
    t20 = $[71];
  }
  let t21;
  if ($[72] !== t13 || $[73] !== t20) {
    t21 = <Div p={t12}>{t13}{t20}</Div>;
    $[72] = t13;
    $[73] = t20;
    $[74] = t21;
  } else {
    t21 = $[74];
  }
  return t21;
};
export default SourcePreview;
function _temp(entry) {
  return {
    created_at: entry["Requests.createdAt"],
    count: entry["Requests.count"],
    status: entry["Requests.status"]?.toLowerCase() || entry["Requests.status"]
  };
}
function _temp2(rollup, data_0) {
  if (!rollup.values[data_0.status]) {
    rollup.values[data_0.status] = 0;
  }
  rollup.values[data_0.status] = rollup.values[data_0.status] + parseInt(data_0.count);
  return rollup;
}